import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../../common/_services/user.service';
@Pipe({
  name: 'datauser',
  pure: true,
  standalone: false,
})
export class DatauserPipe implements PipeTransform {
  constructor(private userService: UserService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.userService.getUserByIdSync(Number(value));
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
